
import { form11StatusInfoType } from '@/types/Information/Form11';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form11ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form11StatusInfoType;

}
